var _style, _g, _g2, _rect, _path, _rect2, _path2, _g3, _g4, _g5, _path3, _g6, _path4, _path5, _polygon, _path6, _path7, _path8, _polygon2, _path9, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportAnalysis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      width: 188
    },
    xmlSpace: "preserve",
    "data-imageid": "report-analysis-2-17",
    imageName: "Report Analysis 2",
    className: "illustrations_image",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0_report-analysis-2-17{fill:#FFFFFF;}\r\n\t.st1_report-analysis-2-17{fill:#474747;}\r\n\t.st2_report-analysis-2-17{fill:#D1D3D4;}\r\n\t.st3_report-analysis-2-17{fill:none;}\r\n\t.st4_report-analysis-2-17{fill:#68E1FD;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tablet_report-analysis-2-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0_report-analysis-2-17",
    d: "M376,297.3H127.3c-6.5,0-11.7-5.2-11.7-11.7V140.1c0-6.5,5.2-11.7,11.7-11.7H376c6.5,0,11.7,5.2,11.7,11.7 v145.6C387.7,292.1,382.5,297.3,376,297.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-2-17",
    d: "M376,298H127.3c-6.8,0-12.4-5.5-12.4-12.4V140.1c0-6.8,5.5-12.4,12.4-12.4H376c6.8,0,12.4,5.5,12.4,12.4v145.6 C388.4,292.5,382.9,298,376,298z M127.3,129.1c-6.1,0-11,4.9-11,11v145.5c0,6.1,4.9,11,11,11H376c6.1,0,11-4.9,11-11V140.1 c0-6.1-4.9-11-11-11L127.3,129.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0_report-analysis-2-17",
    d: "M362.8,284.1H140.5c-5.6,0-10.1-4.5-10.1-10.1V151.7c0-5.6,4.5-10.1,10.1-10.1h222.3c5.6,0,10.1,4.5,10.1,10.1 V274C373,279.5,368.4,284.1,362.8,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-2-17",
    d: "M362.9,284.8H140.5c-6,0-10.8-4.8-10.8-10.8V151.7c0-6,4.9-10.8,10.8-10.8h222.3c6,0,10.8,4.9,10.8,10.8V274 C373.6,280,368.8,284.8,362.9,284.8z M140.5,142.3c-5.2,0-9.4,4.2-9.4,9.4V274c0,5.2,4.2,9.4,9.4,9.4h222.3c5.2,0,9.4-4.2,9.4-9.4 V151.7c0-5.2-4.2-9.4-9.4-9.4H140.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Text_report-analysis-2-17"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st3_report-analysis-2-17",
    x1: 149.2,
    y1: 169.6,
    x2: 204.6,
    y2: 169.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-2-17",
    d: "M204.6,170.4h-55.4c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0h55.4c0.4,0,0.7,0.3,0.7,0.7 C205.3,170,205,170.3,204.6,170.4C204.6,170.4,204.6,170.4,204.6,170.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3_report-analysis-2-17",
    x1: 149.2,
    y1: 184.8,
    x2: 204.6,
    y2: 184.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-2-17",
    d: "M204.6,185.5h-55.4c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0h55.4c0.4,0,0.7,0.3,0.7,0.7 C205.3,185.2,205,185.5,204.6,185.5C204.6,185.5,204.6,185.5,204.6,185.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3_report-analysis-2-17",
    x1: 149.2,
    y1: 200,
    x2: 190.3,
    y2: 200
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-2-17",
    d: "M190.3,200.7h-41.1c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0h41.1c0.4,0,0.7,0.3,0.7,0.7 C191,200.4,190.7,200.7,190.3,200.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3_report-analysis-2-17",
    x1: 358.9,
    y1: 250.3,
    x2: 293.6,
    y2: 250.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-2-17",
    d: "M358.9,251h-65.4c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h65.4c0.4,0,0.7,0.3,0.7,0.7 C359.6,250.7,359.3,251,358.9,251z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3_report-analysis-2-17",
    x1: 346.7,
    y1: 265.1,
    x2: 293.6,
    y2: 265.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-2-17",
    d: "M346.7,265.8h-53.1c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h53.1c0.4,0,0.7,0.3,0.7,0.7 S347.1,265.8,346.7,265.8C346.7,265.8,346.7,265.8,346.7,265.8L346.7,265.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Bar_Chart_report-analysis-2-17"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 256.5,
    y: 199.5,
    className: "st0_report-analysis-2-17",
    width: 24.7,
    height: 27.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-2-17",
    d: "M281.2,227.4h-24.7c-0.4,0-0.7-0.3-0.7-0.7v-27.2c0-0.4,0.3-0.7,0.7-0.7h24.7c0.4,0,0.7,0.3,0.7,0.7 c0,0,0,0,0,0v27.2C281.9,227,281.6,227.4,281.2,227.4L281.2,227.4z M257.2,226h23.3v-25.8h-23.3L257.2,226z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 296.9,
    y: 176.4,
    className: "st0_report-analysis-2-17",
    width: 24.7,
    height: 50.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-2-17",
    d: "M321.5,227.4h-24.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0v-50.3c0-0.4,0.3-0.7,0.7-0.7l0,0h24.7 c0.4,0,0.7,0.3,0.7,0.7c0,0,0,0,0,0v50.3C322.2,227,321.9,227.4,321.5,227.4L321.5,227.4z M297.5,226h23.3v-48.9h-23.3L297.5,226z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 337.2,
    y: 156.4,
    className: "st4_report-analysis-2-17 targetColor",
    width: 24.7,
    height: 70.2,
    style: {
      fill: "rgb(219, 50, 54)"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Bubble_3_report-analysis-2-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0_report-analysis-2-17",
    d: "M437,139.2h-30.1c-4.3,0-7.8,3.5-7.8,7.8v22.3l-23.1,7.4h23.1v0.4c0,4.3,3.5,7.8,7.8,7.8H437 c4.3,0,7.8-3.5,7.8-7.8V147C444.8,142.7,441.3,139.2,437,139.2C437,139.2,437,139.2,437,139.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-2-17",
    d: "M437,185.5h-30.1c-4.6,0-8.3-3.6-8.5-8.1H376c-0.4,0-0.7-0.3-0.7-0.7c0-0.3,0.2-0.6,0.5-0.7l22.6-7.2V147 c0-4.7,3.8-8.5,8.5-8.5H437c4.7,0,8.5,3.8,8.5,8.5v30.1C445.5,181.8,441.7,185.5,437,185.5z M380.5,176h18.6c0.4,0,0.7,0.3,0.7,0.7 c0,0,0,0,0,0v0.4c0,3.9,3.2,7.1,7.1,7.1H437c3.9,0,7.1-3.2,7.1-7.1V147c0-3.9-3.2-7.1-7.1-7.1h-30.1c-3.9,0-7.1,3.2-7.1,7.1v22.3 c0,0.3-0.2,0.6-0.5,0.7L380.5,176z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-2-17",
    d: "M435,153.1h-24.6c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7c0,0,0,0,0,0H435c0.4,0,0.7,0.3,0.7,0.7 S435.4,153.1,435,153.1C435,153.1,435,153.1,435,153.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-2-17",
    d: "M435,162.9h-24.6c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7c0,0,0,0,0,0H435c0.4,0,0.7,0.3,0.7,0.7 C435.7,162.6,435.4,162.9,435,162.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-2-17",
    d: "M428.7,172.6h-18.3c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7c0,0,0,0,0,0h18.3c0.4,0,0.7,0.3,0.7,0.7 C429.4,172.3,429.1,172.6,428.7,172.6z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Bubble_2_report-analysis-2-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0_report-analysis-2-17",
    d: "M124,218.5h-19.5V170c0-3.4-2.7-6.1-6.1-6.1c0,0,0,0,0,0h-37c-3.4,0-6.1,2.7-6.2,6.1c0,0,0,0,0,0v74.2 c0,3.4,2.7,6.1,6.1,6.1h37c3.4,0,6.1-2.7,6.1-6.1v-16.8L124,218.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-2-17",
    d: "M98.4,251h-37c-3.8,0-6.8-3.1-6.8-6.8V170c0-3.8,3.1-6.8,6.8-6.8h37c3.8,0,6.8,3.1,6.8,6.8v47.9H124 c0.4,0,0.7,0.3,0.7,0.7c0,0.3-0.2,0.5-0.4,0.6l-19,8.7v16.3C105.3,248,102.2,251,98.4,251z M61.4,164.5c-3,0-5.4,2.4-5.5,5.4 c0,0,0,0.1,0,0.1v74.2c0,3,2.4,5.4,5.4,5.4h37c3,0,5.4-2.4,5.4-5.4v-16.8c0-0.3,0.2-0.5,0.4-0.6l16.5-7.5h-16.2 c-0.4,0-0.7-0.3-0.7-0.7V170c0-3-2.4-5.4-5.4-5.4L61.4,164.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.7,
    y: 176,
    className: "st0_report-analysis-2-17",
    width: 34.7,
    height: 19.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-2-17",
    d: "M97.4,195.9H62.7c-0.4,0-0.7-0.3-0.7-0.7V176c0-0.4,0.3-0.7,0.7-0.7h34.7c0.4,0,0.7,0.3,0.7,0.7v19.2 C98,195.6,97.7,195.9,97.4,195.9z M63.4,194.5h33.3v-17.8H63.4L63.4,194.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-2-17",
    d: "M97.4,202.3H62.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h34.7c0.4,0,0.7,0.3,0.7,0.7 C98.1,202,97.7,202.3,97.4,202.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-2-17",
    d: "M97.4,211.4H62.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0h34.7c0.4,0,0.7,0.3,0.7,0.7 C98.1,211.1,97.8,211.4,97.4,211.4C97.4,211.4,97.4,211.4,97.4,211.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-2-17",
    d: "M97.4,220.6H62.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0h34.7c0.4,0,0.7,0.3,0.7,0.7 C98.1,220.3,97.8,220.6,97.4,220.6C97.4,220.6,97.4,220.6,97.4,220.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-2-17",
    d: "M97.4,229.7H62.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0h34.7c0.4,0,0.7,0.3,0.7,0.7 C98.1,229.4,97.8,229.7,97.4,229.7C97.4,229.7,97.4,229.7,97.4,229.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-2-17",
    d: "M88.3,238.9H62.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0h25.6c0.4,0,0.7,0.3,0.7,0.7 C89,238.6,88.7,238.9,88.3,238.9z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Bubble_1_report-analysis-2-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0_report-analysis-2-17",
    d: "M318.4,311.4h-80.7l-9.5-33.1v33.1h-25.3c-5.7,0-10.3,4.6-10.3,10.3l0,0v27.8c0,5.7,4.6,10.3,10.3,10.3h115.6 c5.7,0,10.3-4.6,10.3-10.3c0,0,0,0,0,0v-27.8C328.7,316,324.1,311.4,318.4,311.4C318.4,311.4,318.4,311.4,318.4,311.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-2-17",
    d: "M318.4,360.5H202.9c-6.1,0-11-4.9-11-11v-27.8c0-6.1,4.9-11,11-11h24.6v-32.4c0-0.4,0.3-0.6,0.6-0.7 c0.3,0,0.7,0.2,0.8,0.5l9.4,32.6h80.2c6.1,0,11,4.9,11,11v27.8C329.4,355.6,324.5,360.5,318.4,360.5z M202.9,312.1 c-5.3,0-9.6,4.3-9.6,9.6v27.8c0,5.3,4.3,9.6,9.6,9.6h115.6c5.3,0,9.6-4.3,9.6-9.6v-27.8c0-5.3-4.3-9.6-9.6-9.6h-80.7 c-0.3,0-0.6-0.2-0.7-0.5l-8.1-28.3v28.1c0,0.4-0.3,0.7-0.7,0.7H202.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-2-17",
    d: "M306.9,324.8h-71.5c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h71.5c0.4,0,0.7,0.3,0.7,0.7 S307.3,324.8,306.9,324.8C306.9,324.8,306.9,324.8,306.9,324.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-2-17",
    d: "M306.9,336.3h-71.5c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h71.5c0.4,0,0.7,0.3,0.7,0.7 S307.3,336.3,306.9,336.3C306.9,336.3,306.9,336.3,306.9,336.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-2-17",
    d: "M291.2,347.8h-55.8c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h55.8c0.4,0,0.7,0.3,0.7,0.7 S291.6,347.8,291.2,347.8C291.2,347.8,291.2,347.8,291.2,347.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0_report-analysis-2-17",
    cx: 215.9,
    cy: 335.6,
    r: 12.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-2-17",
    d: "M215.9,349c-7.4,0-13.4-6-13.4-13.4c0-7.4,6-13.4,13.4-13.4c7.4,0,13.4,6,13.4,13.4 C229.3,343,223.3,349,215.9,349z M215.9,323.6c-6.6,0-12,5.4-12,12s5.4,12,12,12s12-5.4,12-12C227.9,329,222.5,323.6,215.9,323.6 C215.9,323.6,215.9,323.6,215.9,323.6L215.9,323.6z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0_report-analysis-2-17",
    points: "220.4,324.1 215.9,335.6 223.9,345.4 \t"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-2-17",
    d: "M223.9,346.1c-0.2,0-0.4-0.1-0.5-0.3l-8-9.9c-0.2-0.2-0.2-0.5-0.1-0.7l4.5-11.5c0.1-0.4,0.5-0.5,0.9-0.4 c0.4,0.1,0.5,0.6,0.4,0.9c0,0,0,0,0,0l-4.4,11.1l7.8,9.5c0.3,0.3,0.2,0.7-0.1,1c0,0,0,0,0,0C224.2,346.1,224.1,346.2,223.9,346.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3_report-analysis-2-17",
    x1: 215.9,
    y1: 335.6,
    x2: 204.5,
    y2: 341.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-2-17",
    d: "M204.5,342c-0.3,0-0.5-0.1-0.6-0.4c-0.2-0.3,0-0.8,0.3-0.9l11.4-5.7c0.3-0.2,0.8,0,0.9,0.3 c0.2,0.3,0,0.8-0.3,0.9c0,0,0,0,0,0l-11.4,5.7C204.7,342,204.6,342,204.5,342z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Line_chart_report-analysis-2-17",
    className: "st2_report-analysis-2-17",
    d: "M271.6,268.9c-0.2,0-0.4-0.1-0.5-0.2l-20.7-23.8l-15.1,14.2c-0.3,0.3-0.7,0.3-1,0c0,0,0,0,0,0 l-22.1-22c-0.3-0.3-0.3-0.7,0-1c0.3-0.3,0.7-0.3,1,0c0,0,0,0,0,0l21.7,21.6l15.1-14.2c0.1-0.1,0.3-0.2,0.5-0.2 c0.2,0,0.4,0.1,0.5,0.2l21.2,24.3c0.3,0.3,0.2,0.7,0,1c0,0,0,0,0,0C271.9,268.9,271.8,268.9,271.6,268.9z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "magnifying_glass_report-analysis-2-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0_report-analysis-2-17",
    d: "M179.3,241.6l-0.5-0.4c-2.3-2-2.6-5.4-0.6-7.7v0l28.4-33l0,0l8.8,7.6l0,0l-28.4,33 C185.1,243.3,181.6,243.6,179.3,241.6L179.3,241.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-2-17",
    d: "M182.9,243.6c-1.5,0-2.9-0.5-4-1.5l-0.5-0.4l0,0c-2.6-2.2-2.9-6.1-0.7-8.7c0,0,0,0,0,0l28.4-33 c0.3-0.3,0.7-0.3,1-0.1l8.8,7.6c0.3,0.2,0.3,0.7,0.1,1c0,0,0,0,0,0l-28.4,33c-1.1,1.2-2.6,2-4.2,2.1 C183.2,243.6,183.1,243.6,182.9,243.6z M179.3,240.6l0.5,0.4c2,1.7,5,1.5,6.7-0.5c0,0,0,0,0,0l28-32.5l-7.8-6.7l-28,32.5 C177,235.9,177.3,238.9,179.3,240.6L179.3,240.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.3,
    y: 181.5,
    transform: "matrix(0.6526 -0.7577 0.7577 0.6526 -67.3031 234.9408)",
    className: "st0_report-analysis-2-17",
    width: 42.6,
    height: 18.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-2-17",
    d: "M215.8,213.9c-0.2,0-0.3-0.1-0.4-0.2l-14.3-12.3c-0.3-0.3-0.3-0.7-0.1-1l27.8-32.3c0.1-0.1,0.3-0.2,0.5-0.2 c0.2,0,0.4,0.1,0.5,0.2l14.3,12.3c0.3,0.3,0.3,0.7,0.1,1l-27.8,32.3C216.2,213.7,216.1,213.8,215.8,213.9L215.8,213.9z M202.6,200.8l13.2,11.4l26.9-31.2l-13.2-11.4L202.6,200.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0_report-analysis-2-17",
    d: "M143.2,287.3l-4.2-3.6c-2.8-2.4-3.1-6.6-0.7-9.4l39.7-46.1c2.4-2.8,6.6-3.1,9.4-0.7l4.2,3.6 c2.8,2.4,3.1,6.6,0.7,9.4l-39.7,46.1C150.1,289.4,145.9,289.7,143.2,287.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-2-17",
    d: "M147.5,289.6c-1.8,0-3.5-0.6-4.8-1.8l-4.2-3.6l0,0c-3.1-2.6-3.4-7.3-0.8-10.4l39.7-46.1 c2.6-3.1,7.3-3.4,10.4-0.8l4.2,3.6c3.1,2.6,3.4,7.3,0.8,10.4l-39.7,46.1c-1.3,1.5-3.1,2.4-5,2.5L147.5,289.6z M139.4,283.2l4.2,3.6 c2.5,2.1,6.2,1.8,8.4-0.6l39.7-46c2.1-2.5,1.8-6.2-0.6-8.4l-4.2-3.6c-2.5-2.1-6.2-1.8-8.4,0.6l-39.7,46.1 C136.7,277.3,137,281.1,139.4,283.2L139.4,283.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0_report-analysis-2-17",
    cx: 243.6,
    cy: 166.5,
    r: 50
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-2-17",
    d: "M243.6,217.1c-28,0-50.6-22.8-50.6-50.7s22.8-50.6,50.7-50.6c28,0,50.6,22.8,50.6,50.7 c0,12.1-4.4,23.8-12.3,33C272.4,210.8,258.3,217.2,243.6,217.1z M243.7,117.2c-1.2,0-2.5,0-3.7,0.1c-27.1,2-47.4,25.6-45.3,52.7 s25.6,47.4,52.7,45.3c27.1-2,47.4-25.6,45.3-52.7C290.7,137,269.4,117.2,243.7,117.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0_report-analysis-2-17",
    cx: 243.6,
    cy: 166.5,
    r: 40.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-2-17",
    d: "M243.6,207.8c-22.8,0-41.3-18.5-41.3-41.3c0-9.9,3.6-19.5,10-27l0,0c14.9-17.3,41-19.2,58.2-4.4 c17.3,14.9,19.2,41,4.4,58.2C267.1,202.5,255.6,207.8,243.6,207.8L243.6,207.8z M243.7,126.6c-1,0-2,0-3,0.1 c-10.6,0.8-20.4,5.7-27.3,13.8l0,0c-14.4,16.7-12.5,41.9,4.2,56.3s41.9,12.5,56.3-4.2s12.5-41.9-4.2-56.3 C262.4,130,253.2,126.6,243.7,126.6L243.7,126.6z M212.8,140L212.8,140z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Hands_report-analysis-2-17"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0_report-analysis-2-17",
    d: "M379.9,321.8v-30.3c-5.3-4.7-9.9-10-13.6-16c-6.2-9.9-28.1-46.3-18-49.6s38,30.9,38,30.9l1.4-50.2 c0,0,21.9,17.1,28.5,35.9s3.9,89.3,3.9,89.3L379.9,321.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-2-17",
    d: "M420.1,332.5c-0.1,0-0.1,0-0.2,0l-40.2-9.9c-0.3-0.1-0.5-0.4-0.5-0.7v-30c-5.2-4.7-9.8-10-13.5-15.9 c-5.6-8.9-23.7-38.7-20.3-48c0.4-1.3,1.4-2.3,2.7-2.7c4.5-1.4,12.4,3.4,23.5,14.4c6.2,6.1,11.7,12.5,14.1,15.3l1.4-48.3 c0-0.3,0.2-0.5,0.4-0.6c0.2-0.1,0.5-0.1,0.7,0.1c0.2,0.2,22.1,17.5,28.8,36.2s4,86.7,3.9,89.5c0,0.2-0.1,0.4-0.3,0.5 C420.4,332.4,420.2,332.4,420.1,332.5z M380.6,321.3l38.9,9.6c0.3-8.1,2.2-70.9-3.9-88.2c-5.6-15.9-22.7-30.9-27.2-34.6l-1.4,48.8 c0,0.4-0.3,0.7-0.7,0.7c-0.2,0-0.4-0.1-0.5-0.3c-7.7-9.4-29.4-33.3-37.3-30.7c-0.9,0.3-1.5,0.9-1.8,1.8 c-2.5,6.9,9.3,29.5,20.2,46.7c3.7,5.9,8.2,11.2,13.4,15.8c0.2,0.1,0.3,0.3,0.3,0.5V321.3z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1_report-analysis-2-17",
    points: "426.2,308.4 370.2,308.4 370.2,332.4 431.8,343.9 \t"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-2-17",
    d: "M431.8,344.6h-0.1l-61.6-11.5c-0.3-0.1-0.6-0.4-0.6-0.7v-24c0-0.4,0.3-0.7,0.7-0.7h0h56c0.3,0,0.6,0.3,0.7,0.6 l5.5,35.5c0,0.2,0,0.4-0.2,0.6C432.1,344.6,432,344.6,431.8,344.6z M370.9,331.9l60,11.2l-5.3-33.9h-54.7L370.9,331.9z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st4_report-analysis-2-17 targetColor",
    points: "434.6,326.2 365.2,322.9 365.2,377.8 440.1,370 \t",
    style: {
      fill: "rgb(219, 50, 54)"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0_report-analysis-2-17",
    d: "M142,318.4c2.3-5.1,4.9-10.1,7.8-15c2-3.4,4.1-7.7,6.9-10.5s7-4.6,10.2-7.5c12.2-11,24.5-23.4,28.2-39.5 c0.6-2.6,0.1-6.3-2.5-6.4c-1,0-1.9,0.4-2.7,1c-6.6,4.3-11.4,11.4-17.8,15.4c1.7-1.1,2.2-14.7,3.2-17.4c2.1-5.2,5.3-10.1,7.8-15.2 c1-2.1,2-4.4,1.1-6.6c-0.8-2-3-3.1-5.2-3.1c-2.1,0.1-4.2,0.6-6.2,1.4c-7.5,2.8-14.9,5.9-22.2,9.1c-2.4,0.9-4.7,2.2-6.8,3.8 c-2.2,2-4,4.4-5.4,6.9c-5.6,8.9-21.6,39.2-24,46.1c-0.8,2.5-10.1,31-11.4,30.8L142,318.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-2-17",
    d: "M142,319.1h-0.1l-39-6.7c-0.4-0.1-0.6-0.4-0.6-0.8c0-0.2,0.2-0.4,0.4-0.5c0.7-0.9,3.1-6.6,10.3-28.2 c0.4-1.1,0.6-1.9,0.7-2.2c2.3-6.8,18.2-36.9,24-46.2c1.5-2.6,3.4-5,5.6-7.1c2.1-1.6,4.5-2.9,6.9-3.9c7.3-3.2,14.8-6.3,22.2-9.1 c2-0.9,4.3-1.4,6.5-1.4c2.2,0.1,4.9,1.2,5.8,3.6s-0.1,4.9-1.1,7.1s-2.3,4.3-3.4,6.3c-1.7,2.8-3.1,5.8-4.4,8.8 c-0.5,2.3-0.9,4.6-1.1,7c-0.3,2.8-0.7,5.5-1.2,8.2c2.5-1.9,4.8-4,6.9-6.3c2.7-2.9,5.7-5.5,8.9-7.7c0.9-0.7,2-1.1,3.1-1.1 c0.9,0,1.8,0.5,2.4,1.3c1.2,1.5,1.2,4.1,0.8,6c-3.7,16.4-16.7,29.2-28.4,39.9c-1.6,1.3-3.2,2.5-5,3.6c-1.8,1.1-3.6,2.4-5.1,3.8 c-2.1,2.1-3.9,5.3-5.5,8.1c-0.4,0.8-0.8,1.5-1.2,2.2c-2.8,4.8-5.4,9.8-7.7,14.9C142.5,319,142.3,319.1,142,319.1z M104.2,311.2 l37.4,6.4c2.3-5,4.8-9.8,7.6-14.6c0.4-0.7,0.8-1.4,1.2-2.2c1.6-2.9,3.5-6.2,5.8-8.5c1.7-1.5,3.5-2.9,5.4-4c1.7-1,3.3-2.2,4.8-3.5 c11.6-10.5,24.3-23.1,28-39.1c0.4-1.5,0.3-3.7-0.6-4.9c-0.3-0.4-0.8-0.7-1.3-0.7c-0.8,0.1-1.6,0.4-2.3,0.9c-3.1,2.2-6,4.7-8.7,7.5 c-2.7,2.9-5.8,5.6-9.1,7.8c-0.3,0.2-0.8,0.1-1-0.2c-0.2-0.3-0.1-0.8,0.2-1l0,0c0.8-0.6,1.4-6.3,1.8-9.7c0.2-2.5,0.6-4.9,1.2-7.3 c1.3-3.1,2.8-6.1,4.5-9c1.1-2.1,2.3-4.2,3.3-6.3s1.8-4.2,1.1-6s-2.8-2.6-4.5-2.7c-2,0.1-4.1,0.5-5.9,1.4 c-7.4,2.8-14.9,5.9-22.2,9.1c-2.4,0.9-4.6,2.2-6.6,3.7c-2.1,2-3.9,4.3-5.3,6.8c-5.8,9.2-21.6,39.2-23.9,45.9l-0.7,2.2 C108.1,302.2,105.5,308.9,104.2,311.2z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1_report-analysis-2-17",
    points: "150.8,313.1 97.3,296.4 88.3,320.1 142.8,334.4 \t"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-2-17",
    d: "M142.8,335.1c-0.1,0-0.1,0-0.2,0l-54.5-14.3c-0.2-0.1-0.4-0.2-0.4-0.4c-0.1-0.2-0.1-0.4,0-0.6l9-23.8 c0.1-0.3,0.5-0.5,0.9-0.4l53.5,16.8c0.2,0.1,0.3,0.2,0.4,0.4c0.1,0.2,0.1,0.4,0,0.5l-7.9,21.2C143.4,334.9,143.1,335.1,142.8,335.1 z M89.2,319.6l53.1,13.9l7.5-19.9l-52.1-16.4L89.2,319.6z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st4_report-analysis-2-17 targetColor",
    points: "148.9,331.5 82.9,311.8 60.2,360.9 135.1,384.2 \t",
    style: {
      fill: "rgb(219, 50, 54)"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0_report-analysis-2-17",
    d: "M140.9,317.2c-0.2-0.6-0.5-1.2-1-1.6l-0.8-0.6c-0.6-0.3-1.2-0.5-1.9-0.5h-0.6c-2,0.1-3.6,1.7-3.7,3.7l0.1,1 c0.2,0.6,0.5,1.2,0.9,1.6l0.8,0.6c0.6,0.3,1.2,0.5,1.9,0.5h0.6c0.5,0,1-0.1,1.4-0.3c0.5-0.1,0.9-0.4,1.2-0.8 c0.4-0.3,0.6-0.7,0.8-1.2c0.2-0.4,0.3-0.9,0.3-1.4C141,317.9,140.9,317.5,140.9,317.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0_report-analysis-2-17",
    d: "M380.8,311.4c-4.8,0-4.8,7.4,0,7.4S385.5,311.4,380.8,311.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Pie_Chart_report-analysis-2-17"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-2-17",
    d: "M227,164.5h-13.3c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5c0.4-6.9,3.1-13.4,7.7-18.5 c0.9-1,1.9-2,2.9-2.9c5.1-4.6,11.7-7.3,18.5-7.7c0.4,0,0.7,0.3,0.7,0.6c0,0,0,0,0,0.1v13.3c0,0.4-0.3,0.6-0.6,0.7 c-3.1,0.4-5.9,1.6-8.4,3.5c-1,0.8-1.9,1.7-2.7,2.7c-1.9,2.4-3.1,5.3-3.5,8.4C227.7,164.3,227.4,164.5,227,164.5z M214.5,163.1h11.9 c0.5-3.1,1.7-6,3.7-8.4c0.9-1.1,1.8-2.1,2.9-2.9c2.4-1.9,5.4-3.2,8.4-3.7v-11.9c-6.3,0.5-12.2,3.1-16.9,7.3l0,0 c-1,0.8-1.9,1.8-2.7,2.7C217.6,150.9,215,156.8,214.5,163.1L214.5,163.1z M224,142.9L224,142.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4_report-analysis-2-17 targetColor",
    d: "M274.5,163.8c-0.4-6.7-3.1-13.1-7.5-18.1l-9.4,9.4c2,2.5,3.2,5.5,3.6,8.7c0.1,0.7,0.1,1.3,0.1,2 c0,0.7,0,1.3-0.1,2c-0.4,3.2-1.6,6.2-3.6,8.7c-0.8,1-1.8,2-2.8,2.8c-2.5,2-5.5,3.3-8.7,3.6c-0.7,0.1-1.3,0.1-2,0.1 c-0.7,0-1.3,0-2-0.1c-3.2-0.4-6.2-1.6-8.7-3.6c-3.6-2.8-5.9-7-6.4-11.5h-13.3c0.4,6.7,3.1,13.1,7.5,18.1c0.9,1,1.8,1.9,2.8,2.8 c5,4.4,11.4,7.1,18.1,7.5c0.7,0,1.3,0.1,2,0.1c0.7,0,1.3,0,2-0.1c6.7-0.4,13.1-3.1,18.1-7.5c1-0.9,1.9-1.8,2.8-2.8 c4.4-5,7.1-11.4,7.5-18.1c0-0.7,0.1-1.3,0.1-2S274.6,164.5,274.5,163.8z",
    style: {
      fill: "rgb(219, 50, 54)"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-2-17",
    d: "M254.8,153c-0.2,0-0.3-0.1-0.4-0.1c-2.4-1.9-5.3-3.1-8.4-3.5c-0.4,0-0.6-0.3-0.6-0.7v-13.3 c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0c6.9,0.4,13.4,3.1,18.5,7.7c0.3,0.3,0.3,0.7,0,1c0,0,0,0,0,0l-9.4,9.4 C255.2,152.9,255,153,254.8,153z M246.8,148.1c2.9,0.4,5.6,1.6,7.9,3.3l8.4-8.4c-4.6-3.9-10.3-6.3-16.4-6.8V148.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportAnalysis);
export default __webpack_public_path__ + "static/media/report-analysis.7a75404495d306316d3e5e44716794ec.svg";
export { ForwardRef as ReactComponent };